export function generatePageTypeTrackingData(
  isAnonymous: boolean,
  isB2B: boolean,
  pageType: string,
  userId: string | undefined,
  numberOfOrders?: number,
  frameworkDiscount?: boolean,
  usedGuidedSelling?: boolean,
  guidedSellingCampaign?: string
) {
  const trackingData = {
    user: {
      loginStatus: isAnonymous ? "logged-out" : "logged-in",
      type: isB2B ? "B2B" : "B2C",
    },
    page: {
      type: pageType,
    },
  }

  if (userId) {
    trackingData.user["id"] = userId
  }

  if (numberOfOrders) {
    trackingData.user["numberOfOrders"] = numberOfOrders
  }

  if (frameworkDiscount) {
    trackingData.user["frameworkDiscount"] = "" + frameworkDiscount
  }

  // Add guided‑selling flags if provided
  if (usedGuidedSelling !== undefined) {
    trackingData.user["used_guided_selling"] = usedGuidedSelling ? "true" : "false"
  }

  if (guidedSellingCampaign) {
    trackingData.user["guided_selling_campaign"] = guidedSellingCampaign
  }

  return trackingData
}
